/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum Source {
  Dashboard = "dashboard",
  Publicapi = "publicapi",
  Apollo = "apollo",
  Shopify = "shopify",
  Bigcommerce = "bigcommerce",
}

export function instanceOfSource(value: any): boolean {
  for (const key in Source) {
    if (Object.prototype.hasOwnProperty.call(Source, key)) {
      if (Source[key as keyof typeof Source] === value) {
        return true;
      }
    }
  }
  return false;
}

export function SourceFromJSON(json: any): Source {
  return SourceFromJSONTyped(json, false);
}

export function SourceFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): Source {
  return json as Source;
}

export function SourceToJSON(value?: Source | null): any {
  return value as any;
}

export function SourceToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): Source {
  return value as Source;
}
